'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('@/utils');

exports.default = {
  data: function data() {
    return {
      liveSrc: '',
      liveLink: '',
      showLive: true,
      clickTrigger: true
    };
  },
  created: function created() {
    var _this = this;

    this.$ajax({
      url: 'api-information/portal/open/liveBroadcast',
      data: {}
    }).then(function (_ref) {
      var data = _ref.data;

      if (!data.data || !data.data.length) return;
      var item = data.data[0];
      _this.liveSrc = (0, _utils.imagePath)('zero', item.imageID);
      _this.liveLink = item.link;
    });
  },

  methods: {
    toToTop: function toToTop() {
      var _this2 = this;

      var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollTop <= 0) return;
      var nextFrame = this.nextFrame;
      window.scrollTo(0, scrollTop - 50);
      nextFrame(function () {
        _this2.toToTop();
      });
    },
    nextFrame: function nextFrame(fn) {
      var _this3 = this;

      window.requestAnimationFrame(function () {
        fn.call(_this3);
      });
    },
    changeLive: function changeLive() {
      this.showLive = !this.showLive;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//